import type { LocationQuery } from 'vue-router';

export interface SocialReturnParams {
  flow: string;
  email: string;
  firstName: string;
  lastName: string;
  provider: string;
}

/**
 * New-role social OAuth logins land back on the initiating page with social_*
 * query params (see pages/unified/auth/callback.vue). Existing-role users never
 * get here — the callback completes their login and redirects to the dashboard.
 * Returns null when the query carries no social_flow or the email is missing/blank.
 */
export const parseSocialReturnFromQuery = (query: LocationQuery): SocialReturnParams | null => {
  const flow = typeof query.social_flow === 'string' ? query.social_flow : '';
  const email = typeof query.social_email === 'string' ? query.social_email.trim() : '';
  if (!flow || !email) {
    return null;
  }

  return {
    flow,
    email,
    firstName: typeof query.social_first_name === 'string' ? query.social_first_name : '',
    lastName: typeof query.social_last_name === 'string' ? query.social_last_name : '',
    provider: typeof query.social_provider === 'string' ? query.social_provider : '',
  };
};
